import { useState } from "react";
import Select from "react-select";
import makeAnimated from "react-select/animated";
import { Button } from "../../elements/Button";
import CustomDropdownIndicator from "../../elements/CustomDropdownIndicator";
import buttoncss from "../../css/button.module.css";
import icrCss from "../../css/interCompanyEliminations.module.css";
import { ReactComponent as PlusPrimary } from "../../assets/icons/primary_plus.svg"
import { ReactComponent as Export } from "../../assets/icons/export.svg"
import { ReactComponent as LeftArrowIcon } from "../../assets/icons/left_arrow.svg"
import { ReactComponent as DotIcon } from "../../assets/icons/dot.svg"
import { ReactComponent as DoubleArrowsIcon } from "../../assets/icons/doubleArrows.svg"
import { ReactComponent as DeleteRedIcon } from "../../assets/icons/delete_red.svg"



export const customStyles = {
    control: (provided, state) => ({
        ...provided,
        backgroundColor: '#f4faf5',
        borderColor: '#c2e6d1',
        color: '#b3c0bd',
        boxShadow: state.isFocused ? '0 0 0 1px #c2e6d1' : 'none',
        borderWidth: '1px',
        borderRadius: '10px',
        '&:hover': {
            borderColor: '#b3c0bd',
        },
        minHeight: '38px',
        height: '38px',
    }),
    valueContainer: (provided) => ({
        ...provided,
        padding: '2px 8px',
        paddingTop: '1px',
    }),
    input: (provided) => ({
        ...provided,
        color: '#b3c0bd',
    }),
    placeholder: (provided) => ({
        ...provided,
        color: '#b3c0bd',
        fontSize: '14px',
    }),
    singleValue: (provided) => ({
        ...provided,
        color: '#4d6d64',
        fontSize: '14px',
    }),
    multiValue: (provided) => ({
        ...provided,
        backgroundColor: '#e0f5e9',
        borderRadius: '0.25rem',
        border: '1px solid #c2e6d1',
        width: 'fit-content',
    }),
    multiValueLabel: (provided) => ({
        ...provided,
        color: '#4d6d64',
    }),
    multiValueRemove: (provided) => ({
        ...provided,
        color: '#b3c0bd',
        ':hover': {
            backgroundColor: '#c2e6d1',
            color: '#4f665f',
        },
    }),
    indicatorsContainer: (provided) => ({
        ...provided,
        color: '#b3c0bd',
    }),
    dropdownIndicator: (provided) => ({
        ...provided,
        color: '#1A4338',
        fontWeight: 400,
        ':hover': {
            color: '#1A4338',
            fontWeight: 400,
        },
    }),
    clearIndicator: (provided) => ({
        ...provided,
        color: '#b3c0bd',
        ':hover': {
            color: '#4f665f',
        },
    }),
    menu: (provided) => ({
        ...provided,
        backgroundColor: '#ffffff',
        border: '1px solid #c2e6d1',
        borderRadius: '6px',
        boxShadow: '0 0 0 1px #c2e6d1',
        marginTop: '6px',
        zIndex: 10,
    }),
    menuList: (provided) => ({
        ...provided,
        padding: '4px',
        borderRadius: '6px',
    }),
    option: (provided, state) => ({
        ...provided,
        backgroundColor: state.isSelected
            ? '#c2e6d1'
            : state.isFocused
                ? '#f4faf5'
                : 'transparent',
        color: '#4f665f',
        padding: '10px 12px',
        cursor: 'pointer',
        fontSize: '14px',
        borderRadius: '8px',
        // margin: '4px 6px',
    }),
    noOptionsMessage: (provided) => ({
        ...provided,
        color: '#b3c0bd',
        padding: '8px 12px',
    }),
};

const ICEWorkings = ({ setEliminationScreen }) => {

    const animatedComponents = makeAnimated();

    const [rows, setRows] = useState([0]);
    const [showAll, setShowAll] = useState(false);

    const [balancesRows, setBalancesRows] = useState([0]);
    const [showAllBalancesRows, setShowAllBalancesRows] = useState(false);


    const transactionOptions = [
        { label: "Sales Invoice", value: "sales_invoice" },
        { label: "Sales Return", value: "sales_return" },
        { label: "Purchase Bill", value: "purchase_bill" },
        { label: "Purchase Return", value: "purchase_return" },
        { label: "Bank Deposit", value: "bank_deposit" },
        { label: "Bank Withdrawal", value: "bank_withdrawal" },
        { label: "Cash Receipt", value: "cash_receipt" },
        { label: "Cash Payment", value: "cash_payment" },
        { label: "Journal Entry", value: "journal_entry" },
        { label: "Fund Transfer", value: "fund_transfer" },
    ];

    const purchaseOptions = [
        { label: "Purchase Order", value: "purchase_order" },
        { label: "Purchase Invoice", value: "purchase_invoice" },
        { label: "Purchase Return", value: "purchase_return" },
        { label: "Vendor Payment", value: "vendor_payment" },
        { label: "Advance to Vendor", value: "advance_to_vendor" },
        { label: "Expense Claim", value: "expense_claim" },
        { label: "Utility Bill", value: "utility_bill" },
        { label: "Rent Payment", value: "rent_payment" },
        { label: "Goods Receipt Note", value: "goods_receipt" },
        { label: "Import Charges", value: "import_charges" },
    ];

    const transactionTableData = [
        {
            leftParticular: "Bank Deposit",
            leftAmount: 3200,
            rightParticular: "Cash Receipt",
            rightAmount: 3200,
            reconcile: 3200,
            difference: 0,
        },
        {
            leftParticular: "Sales Invoice",
            leftAmount: 4500,
            rightParticular: "Sales Return",
            rightAmount: 3800,
            reconcile: 3800,
            difference: 700,
        },
        {
            leftParticular: "Journal Entry",
            leftAmount: 2100,
            rightParticular: "Adjustment Entry",
            rightAmount: 2100,
            reconcile: 2000,
            difference: 100,
        },
        {
            leftParticular: "Fund Transfer",
            leftAmount: 5000,
            rightParticular: "Company Transfer",
            rightAmount: 4700,
            reconcile: 4700,
            difference: 300,
        },
        {
            leftParticular: "Opening Balance",
            leftAmount: 1500,
            rightParticular: "Write-off",
            rightAmount: 1500,
            reconcile: 1500,
            difference: 0,
        },
        {
            leftParticular: "Bank Deposit",
            leftAmount: 3200,
            rightParticular: "Cash Receipt",
            rightAmount: 3200,
            reconcile: 3200,
            difference: 0,
        },
        {
            leftParticular: "Sales Invoice",
            leftAmount: 4500,
            rightParticular: "Sales Return",
            rightAmount: 3800,
            reconcile: 3800,
            difference: 700,
        },
        {
            leftParticular: "Bank Deposit",
            leftAmount: 3200,
            rightParticular: "Cash Receipt",
            rightAmount: 3200,
            reconcile: 3200,
            difference: 0,
        },
        {
            leftParticular: "Sales Invoice",
            leftAmount: 4500,
            rightParticular: "Sales Return",
            rightAmount: 3800,
            reconcile: 3800,
            difference: 700,
        },
        {
            leftParticular: "Bank Deposit",
            leftAmount: 3200,
            rightParticular: "Cash Receipt",
            rightAmount: 3200,
            reconcile: 3200,
            difference: 0,
        },
        {
            leftParticular: "Sales Invoice",
            leftAmount: 4500,
            rightParticular: "Sales Return",
            rightAmount: 3800,
            reconcile: 3800,
            difference: 700,
        }
    ];

    const purchaseTableData = [
        {
            leftParticular: "Purchase Order",
            leftAmount: 2600,
            rightParticular: "Purchase Invoice",
            rightAmount: 2600,
            reconcile: 2600,
            difference: 0,
        },
        {
            leftParticular: "Vendor Payment",
            leftAmount: 3200,
            rightParticular: "Purchase Return",
            rightAmount: 2900,
            reconcile: 2900,
            difference: 300,
        },
        {
            leftParticular: "Expense Claim",
            leftAmount: 1800,
            rightParticular: "Utility Bill",
            rightAmount: 1800,
            reconcile: 1800,
            difference: 0,
        },
        {
            leftParticular: "Advance to Vendor",
            leftAmount: 4000,
            rightParticular: "Goods Receipt",
            rightAmount: 3900,
            reconcile: 3900,
            difference: 100,
        },
        {
            leftParticular: "Import Charges",
            leftAmount: 2400,
            rightParticular: "Rent Payment",
            rightAmount: 2400,
            reconcile: 2400,
            difference: 0,
        },
        {
            leftParticular: "Purchase Order",
            leftAmount: 2600,
            rightParticular: "Purchase Invoice",
            rightAmount: 2600,
            reconcile: 2600,
            difference: 0,
        },
        {
            leftParticular: "Vendor Payment",
            leftAmount: 3200,
            rightParticular: "Purchase Return",
            rightAmount: 2900,
            reconcile: 2900,
            difference: 300,
        },
        {
            leftParticular: "Vendor Payment",
            leftAmount: 3200,
            rightParticular: "Purchase Return",
            rightAmount: 2900,
            reconcile: 2900,
            difference: 300,
        },
        {
            leftParticular: "Purchase Order",
            leftAmount: 2600,
            rightParticular: "Purchase Invoice",
            rightAmount: 2600,
            reconcile: 2600,
            difference: 0,
        },
        {
            leftParticular: "Vendor Payment",
            leftAmount: 3200,
            rightParticular: "Purchase Return",
            rightAmount: 2900,
            reconcile: 2900,
            difference: 300,
        },
        
    ];


    const handleAddRow = () => {
        setRows((prev) => [...prev, prev.length]);
    };

    const handleAddBalancesRow = () => {
        setBalancesRows((prev) => [...prev, prev.length]);
    };

    const handleDeleteRow = (index) => {
        const updated = rows.filter((_, i) => i !== index);
        setRows(updated);
    };

    const handleDeleteBalancesRow = (index) => {
        const updated = balancesRows.filter((_, i) => i !== index);
        setBalancesRows(updated);
    };

    const visibleRows = showAll ? rows : rows.slice(0, 4);
    const visibleBalancesRows = showAllBalancesRows ? balancesRows : balancesRows.slice(0, 4);

    return (
        <>
            <div className={icrCss.header}>
                <div style={{ display: "flex", alignItems: "center", gap: "15px", fontSize: "14px" }}>
                    <span style={{ cursor: "pointer" }} onClick={() => setEliminationScreen(0)}>
                        <span>
                            <LeftArrowIcon height={12} style={{ marginBottom: "2px" }} />
                        </span>
                        <span style={{ color: "#4D6D64", marginLeft: "10px" }}>
                            Inter company elimination
                        </span>
                    </span>
                    <span>
                        <DotIcon />
                    </span>
                    <span>View workings</span>
                </div>

                <div style={{ display: "flex", alignItems: "center", gap: "15px", fontSize: "10px" }}>
                    <Button
                        icon={<Export height={16} />}
                        btnColor={buttoncss.greyBg}
                        label="Export Workings"
                    />

                    <Button
                        btnColor={buttoncss.primary}
                        label="Perform reconciliation"
                        onClick={() => setEliminationScreen(2)}
                    />
                </div>
            </div>

            <div className={icrCss.workingsPanelCtn}>

                <div className={icrCss.workingsPanel}>

                    <div className={icrCss.panelHeader}>
                        <label className="mb-0">Select transactions to be compared</label>
                        <div className="d-flex align-items-center" style={{ gap: "5px" }}>
                            <Button
                                class_={icrCss.panelButton}
                                icon={<PlusPrimary />}
                                btnColor={buttoncss.secondary}
                                onClick={handleAddRow}
                                label="Add New"
                            />
                            <Button
                                class_={icrCss.panelButton}
                                btnColor={buttoncss.primary}
                                label="Save"
                            />
                        </div>
                    </div>

                    <div className={icrCss.transactionInputsRowCtn}>
                        {visibleRows.map((_, index) => (
                            <div key={index} className={icrCss.transactionInputsRow}>
                                <Select
                                    placeholder="Select transaction"
                                    className={`w-100`}
                                    options={transactionOptions}
                                    classNamePrefix="select"
                                    components={{
                                        ...animatedComponents,
                                        IndicatorSeparator: () => null,
                                        DropdownIndicator: CustomDropdownIndicator,
                                    }}
                                    styles={customStyles}
                                />
                                <DoubleArrowsIcon style={{ minWidth: "18px" }} />
                                <Select
                                    placeholder="Select transaction"
                                    options={transactionOptions}
                                    className={`w-100`}
                                    classNamePrefix="select"
                                    components={{
                                        ...animatedComponents,
                                        IndicatorSeparator: () => null,
                                        DropdownIndicator: CustomDropdownIndicator,
                                    }}
                                    styles={customStyles}
                                />
                                <DeleteRedIcon
                                    className={icrCss.deleteIcon}
                                    style={{ minWidth: "16px", marginLeft: "3px", cursor: "pointer" }}
                                    onClick={() => handleDeleteRow(index)}
                                />
                            </div>
                        ))}

                        {rows.length > 4 && (
                            <div className="text-right mt-2">
                                <button
                                    style={{ border: "none" }}
                                    className={`${buttoncss.secondary} btn-sm`}
                                    onClick={() => setShowAll((prev) => !prev)}
                                >
                                    {showAll ? "View Less" : "View More"}
                                </button>
                            </div>
                        )}
                    </div>
                    <div className={icrCss.seperator}></div>
                    <div className={icrCss.panelTableCtn}>
                        <table className={icrCss.panelTable}>
                            <thead>
                                <tr>
                                    <th style={{ textAlign: "left" }}>Particulars</th>
                                    <th>Amount</th>
                                    <th style={{ textAlign: "left" }}>Particulars</th>
                                    <th>Amount</th>
                                    <th>Reconcile</th>
                                    <th>Difference</th>
                                </tr>
                            </thead>
                            <tbody>
                                {transactionTableData.map((row, i) => (
                                    <tr key={i}>
                                        <td style={{ textAlign: "left" }}>{row.leftParticular}</td>
                                        <td>{row.leftAmount}</td>
                                        <td style={{ textAlign: "left" }}>{row.rightParticular}</td>
                                        <td>{row.rightAmount}</td>
                                        <td>{row.reconcile}</td>
                                        <td style={{ color: row.difference !== 0 ? "#E30000" : "inherit" }}>{row.difference}</td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                </div>

                <div className={icrCss.workingsPanel}>
                    <div className={icrCss.panelHeader}>
                        <label className="mb-0">Select balances to be compared</label>
                        <div className="d-flex align-items-center" style={{ gap: "5px" }}>
                            <Button
                                class_={icrCss.panelButton}
                                icon={<PlusPrimary />}
                                btnColor={buttoncss.secondary}
                                onClick={handleAddBalancesRow}
                                label="Add New"
                            />
                            <Button
                                class_={icrCss.panelButton}
                                btnColor={buttoncss.primary}
                                label="Save"
                            />
                        </div>
                    </div>

                    <div className={icrCss.transactionInputsRowCtn}>
                        {visibleBalancesRows.map((_, index) => (
                            <div key={index} className={icrCss.transactionInputsRow}>
                                <Select
                                    placeholder="Select balances"
                                    className={`w-100`}
                                    options={purchaseOptions}
                                    classNamePrefix="select"
                                    components={{
                                        ...animatedComponents,
                                        IndicatorSeparator: () => null,
                                        DropdownIndicator: CustomDropdownIndicator,
                                    }}
                                    styles={customStyles}
                                />
                                <DoubleArrowsIcon style={{ minWidth: "18px" }} />
                                <Select
                                    placeholder="Select balances"
                                    className={`w-100`}
                                    options={purchaseOptions}
                                    classNamePrefix="select"
                                    components={{
                                        ...animatedComponents,
                                        IndicatorSeparator: () => null,
                                        DropdownIndicator: CustomDropdownIndicator,
                                    }}
                                    styles={customStyles}
                                />
                                <DeleteRedIcon
                                    className={icrCss.deleteIcon}
                                    style={{ minWidth: "16px", marginLeft: "3px", cursor: "pointer" }}
                                    onClick={() => handleDeleteBalancesRow(index)}
                                />
                            </div>
                        ))}

                        {balancesRows.length > 4 && (
                            <div className="text-right mt-2">
                                <button
                                    style={{ border: "none" }}
                                    className={`${buttoncss.secondary} btn-sm`}
                                    onClick={() => setShowAllBalancesRows((prev) => !prev)}
                                >
                                    {showAll ? "View Less" : "View More"}
                                </button>
                            </div>
                        )}
                    </div>

                    <div className={icrCss.seperator}></div>
                    <div className={icrCss.panelTableCtn}>
                        <table className={icrCss.panelTable}>
                            <thead>
                                <tr>
                                    <th style={{ textAlign: "left" }}>Particulars</th>
                                    <th>Amount</th>
                                    <th style={{ textAlign: "left" }}>Particulars</th>
                                    <th>Amount</th>
                                    <th>Reconcile</th>
                                    <th>Difference</th>
                                </tr>
                            </thead>
                            <tbody>
                                {purchaseTableData.map((row, i) => (
                                    <tr key={i}>
                                        <td style={{ textAlign: "left" }}>{row.leftParticular}</td>
                                        <td>{row.leftAmount}</td>
                                        <td style={{ textAlign: "left" }}>{row.rightParticular}</td>
                                        <td>{row.rightAmount}</td>
                                        <td>{row.reconcile}</td>
                                        <td style={{ color: row.difference !== 0 ? "#E30000" : "inherit" }}>{row.difference}</td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </>
    )

}

export default ICEWorkings;